import { color } from "@/helpers/colors";
import ShadowMetricsLogo from "@/assets/shadow-metrics-logo.png";
import WebImpactLogo from "@/assets/webimpact-logo.png";
import DacideLogo from "@/assets/dacide-logo.png";
import OMGroupLogo from "@/assets/omgroup-logo.png";
import colors from 'vuetify/lib/util/colors'

const branding = host => {
    switch (host) {
        case "shadow-metrics.com":
            return {
                name: "Shadow Metrics",
                logo: ShadowMetricsLogo,
                footer: `${new Date().getFullYear()} — <strong>Dacide</strong> &amp; <strong>Impact Solutions</strong>`,
                color: colors.indigo
            };
        case "dashboard.dacide.com":
            return {
                name: "Dacide Dashboard",
                logo: DacideLogo,
                footer: `${new Date().getFullYear()} — <strong>Dacide</strong>`,
                color: "#33856B"
            };
        case "my.omgroup.ch":
                return {
                    name: "Online Marketing Group",
                    logo: OMGroupLogo,
                    footer: `${new Date().getFullYear()} — <strong>OMGroup.ch</strong>`,
                    color: "#069dc6"
                };
        default:
            return {
                name: "WebImpact",
                logo: WebImpactLogo,
                footer: `${new Date().getFullYear()} — <strong>Impact Solutions</strong>`,
                color: "#0e518d"
            };
    }
};

export default {
    charts: {
        dataset: i => ({
            pointBackgroundColor: color(i),
            borderWidth: 1,
            pointRadius: 5,
            pointBorderColor: 'rgba(255, 255, 255, 0.4)',
            borderColor: color(i),
        })
    },
    pies: {
        dataset: i => ({
            pointBackgroundColor: color(i),
            borderWidth: 1,
            pointRadius: 5,
            pointBorderColor: 'rgba(255, 255, 255, 0.4)',
            borderColor: color(i),
        })
    },
    branding: branding(location.host)
};